import * as Yup from 'yup';

export const AddTicketSchema = Yup.object().shape({
  title: Yup.string()
    .required('Title required'),
  message: Yup.string()
    .required('Message required')
});


export const ChatSchema = Yup.object().shape({
  message: Yup.string()
    .required('Message required')
});
